exports.version = "2.4.2"


//////////////////
// WEBPACK FOOTER
// ./~/apollo-client/version.js
// module id = 1440
// module chunks = 0